/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export * from "./swap-items";

export const insertRowBeforeIdx = (arr, idx) => {
    const row = new Array(arr[0].length).fill("");
    const before = arr.slice(0, idx);
    const after = arr.slice(idx);
    const retval = [...before, row, ...after];
    return retval;
};

export const insertRowAfterIdx = (arr, idx) => {
    const row = new Array(arr[0].length).fill("");
    const before = arr.slice(0, idx + 1);
    const after = arr.slice(idx + 1);
    const retval = [...before, row, ...after];
    return retval;
};

export const insertColumnAfterIdx = (arr, idx) => {
    const retval = arr.map((row) => {
        return insertRowAfterIdx(row, idx);
    });
    return retval;
};

export const insertColumnBeforeIdx = (arr, idx) => {
    const retval = arr.map((row) => {
        return insertRowBeforeIdx(row, idx);
    });
    return retval;
};

export const cloneObjectsArray = (array) => {
    const replacement = [];
    if (Array.isArray(array)) {
        for (const item of array) {
            const obj = JSON.parse(JSON.stringify(item));
            replacement.push({ ...obj });
        }
    }
    return replacement;
};
